type AddUserBonusProps = {
  userId: string
  bonusBalance?: number
  onSuccess: () => void
  setOpen: (value: boolean) => void
}

export const AddUserBonus = ({ setOpen }: AddUserBonusProps) => {
  return (
    <>
      {setOpen && (
        <button className="btn-secondary flex gap-3 py-2 px-6 rounded-[4px] text-white capitalize text-base" onClick={() => setOpen(true)}>
          Add Bonus
        </button>
      )}
    </>
  )
}
